import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Modal, message } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { createScreenShowAction } from './actions';

console.log(moment().format('YYYY-MM-DD'), '1111123222');

class ScreenShotFrame extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            previewUrl: '',
            isShowPreview: false,
            randoms: window.localStorage.getItem('randoms'),
        };
    }
    componentWillMount() {
    }
    componentDidMount() {}
    handleOk() {
        this.props.changeScreenShotStatus(false);
        let randoms = window.localStorage.getItem('randoms')
        randoms++;
        this.setState({
            randoms: randoms,
        })
        window.localStorage.randoms = randoms;
    }
    handleCancel() {
        this.props.changeScreenShotStatus(false);
        let randoms = window.localStorage.getItem('randoms')
        randoms++;
        this.setState({
            randoms: randoms,
        })
        window.localStorage.randoms = randoms;
    }
    handleCancelPreview() {
        this.setState({
            isShowPreview: false,
        });

    }

    ulClick = e => {
        if (e.target.tagName === 'IMG') {
            this.setState({
                isShowPreview: true,
                previewUrl:
                    'https://images.adcube.com.cn/images/' +
                    this.props.startTimes +
                    '/' +
                    this.props.itemRecord.taskId +
                    '/page_' +
                    this.props.itemRecord.taskId +
                    '_' +
                    e.target.getAttribute('data-index') +
                    '.png?rnd=' +
                    this.state.randoms,
            });
        }
    };
    render() {
        console.log('11111');
        const time = this.props.startTimes;
        const itemData = this.props.itemRecord;
        let listImgHtml = '';
        if (itemData && this.props.isShowScreenFrame) {
            for (let index = 0; index < 30; index++) {
                // let srcs =
                //     'https://images.radobox.com.cn/images/' +
                //     time +
                //     '/' +
                //     itemData.taskId +
                //     '/page_' +
                //     itemData.taskId +
                //     '_' +
                //     index +
                //     '.png?rnd=' +
                //     this.state.randoms;
                let smallSrcs =
                    'https://images.adcube.com.cn/images/' +
                    time +
                    '/' +
                    itemData.taskId +
                    '/page_' +
                    itemData.taskId +
                    '_' +
                    index +
                    '.png!w300x200.png?rnd=' +
                /*    index +
                    '.png?rnd=' +*/
                    this.state.randoms;
                listImgHtml +=
                    '<div style="float:left;width:15%;height:60px;margin-right:10px;margin-bottom:10px;border:1px solid #ddd;text-align:center;overflow:hidden;"><img style="width:100%" src=' +
                    smallSrcs +
                    ' data-index=' +
                    index +
                    '></div>';
            }
        }

        return (
            <div>
                <Modal
                    width="60%"
                    title="截图展示"
                    visible={this.props.isShowScreenFrame}
                    onOk={() => this.handleOk()}
                    onCancel={() => this.handleCancel()}
                    footer={null}>
                    <div
                        dangerouslySetInnerHTML={{ __html: listImgHtml }}
                        style={{ width: '100%', height: '100%', overflow: 'auto' }}
                        onClick={this.ulClick}
                    />
                </Modal>
                <Modal
                    width="60%"
                    title="图片预览"
                    visible={this.state.isShowPreview}
                    // visible={this.changeLocalStorge() === true ? true : false}
                    onCancel={() => this.handleCancelPreview()}
                    footer={null}>
                    <div style={{ width: '100%', textAlign: 'center', overflow: 'hidden' }}>
                        <img src={this.state.previewUrl} />
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isShowScreenFrame: state.tasklist.screenShow.isShowScreen,
    itemRecord: state.tasklist.printTaskData,
});

const mapDispatchToProps = dispatch => ({
    changeScreenShotStatus: status => dispatch(createScreenShowAction(status)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ScreenShotFrame);



// WEBPACK FOOTER //
// ./pages/task/tasklist/screenshotFrame.js